import { Singleton } from 'typescript-ioc';
import { EventContext, EventHandler, EventName, IEventDispatcher } from '../event-dispatcher';

@Singleton
export class EventDispatcherService extends IEventDispatcher {
    private handlers: Record<EventName, Set<EventHandler<object>>> | {} = {};

    constructor() {
        super();

        Object.values(EventName).forEach(name => {
            this.handlers[name] = new Set();
        });
    }

    public dispatch<T extends object>(eventName: EventName, event: T, context?: EventContext): void {
        this.handlers[eventName].forEach(handler => handler(event, context));
    }

    public registerHandler<T extends object>(eventName: EventName, handler: EventHandler<T>): void {
        this.handlers[eventName].add(handler);
    }

    public unregisterHandler<T extends object>(eventName: EventName, handler: EventHandler<T>): void {
        this.handlers[eventName].delete(handler);
    }
}
